/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrytickets1Inputs */

const en_entrytickets1 = /** @type {(inputs: Entrytickets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets on Pulsify`)
};

const de_entrytickets1 = /** @type {(inputs: Entrytickets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets über Pulsify`)
};

/**
* | output |
* | --- |
* | "Tickets on Pulsify" |
*
* @param {Entrytickets1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrytickets1 = /** @type {((inputs?: Entrytickets1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrytickets1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrytickets1(inputs)
	return de_entrytickets1(inputs)
});
export { entrytickets1 as "entryTickets" }